import { useState, useEffect, useCallback } from 'react';
import { useLoader } from '@/contexts/loader/LoaderContext';
import { useErrorHandling } from '@/utils/errorHandling';
import { Alert, Stack, Table, TableBody, TableContainer } from '@mui/material';
import {
    ActionType,
    ConsentResponse,
    GetConsentsResponse
} from '@/models/company';
import UsersAPIServiceV2 from '@/services/UserServiceV2';
import { useFormatting } from '@/utils/formatting';
import {
    TableCell,
    TableHeader,
    TableRow,
    TableHeaderCell
} from '@/components/shared/styles/Table';
import { TableCard } from '@/components/shared/Card';
import CardHeader from '@/components/shared/CardHeader';
import Chip from '@/components/shared/Chip';
import { useCurrentCompanyDetails } from '@/services/paymentsQuery';
import { useTranslation } from 'react-i18next';

export const AddOnTable = () => {
    const { getBalanceLabel } = useFormatting();

    const { data } = useCurrentCompanyDetails();
    const { t } = useTranslation();

    return (
        <>
            {(data?.data?.addOnServices?.length ?? 0) > 0 && (
                <TableCard style={{ marginBottom: '24px' }}>
                    <CardHeader
                        label={
                            <Stack direction={'row'} alignItems={'center'}>
                                {t('add_ons')}
                            </Stack>
                        }
                    ></CardHeader>
                    <TableContainer>
                        <Table sx={{ minWidth: 650 }} aria-label="simple table">
                            <TableHeader>
                                <TableRow>
                                    <TableHeaderCell
                                        sx={{
                                            fontWeight: 'bold',
                                            width: '45%'
                                        }}
                                    >
                                        {t('service')}
                                    </TableHeaderCell>
                                    <TableHeaderCell
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        {t('base_price')}
                                    </TableHeaderCell>
                                    <TableHeaderCell
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        {t('quantity')}
                                    </TableHeaderCell>
                                    <TableHeaderCell
                                        align="right"
                                        sx={{ fontWeight: 'bold' }}
                                    >
                                        {t('total_price')}
                                    </TableHeaderCell>
                                </TableRow>
                            </TableHeader>
                            <TableBody>
                                {data?.data?.addOnServices?.map((item) => {
                                    return (
                                        <TableRow key={item.service}>
                                            <TableCell>
                                                {item?.service}
                                            </TableCell>
                                            <TableCell>
                                                {getBalanceLabel(
                                                    item.basePrice,
                                                    data?.data?.currency
                                                )}
                                            </TableCell>
                                            <TableCell>
                                                {item.locations}
                                            </TableCell>
                                            <TableCell align="right">
                                                {getBalanceLabel(
                                                    item.totalPrice,
                                                    data?.data?.currency
                                                )}
                                            </TableCell>
                                        </TableRow>
                                    );
                                })}
                            </TableBody>
                        </Table>
                    </TableContainer>
                </TableCard>
            )}
        </>
    );
};
